<script>
import selectedProductsComponent from '../selected_products/selected_products.vue';

export default {
  data() {
    return {
      client_comment: '',
    };
  },
  watch: {
    selectedProducts: {
      handler(products) {
        if (products.length === 0) this.$store.dispatch('isset_selected_fba', null);
      },
      deep: true,
    },
  },
  components: {
    selected_products_component: selectedProductsComponent,
  },
  computed: {
    selectedProducts() {
      return this.$store.getters.getSelectedProducts;
    },
    isButtonActive() {
      const isInvalid = this.selectedProducts
        .map((item) => item.filter((subItem) => subItem.valid === false).length === 0);

      const invalid = (element) => element === false;
      return isInvalid.some(invalid);
    },
  },
  methods: {
    create_fba() {
      const prepareData = {
        client_comment: this.client_comment,
        products: this.$store.getters.getSelectedProductsIds,
      };

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'iscreate_fba',
        action_data: prepareData,
        inform_message: 'Create FBA',
      });
    },
    close(event) {
      if (typeof event === 'undefined') {
        this.$store.dispatch('isset_selected_fba', null);
      }

      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.dispatch('isset_selected_fba', null);
      }
    },
  },
};
</script>
<template src="./send_FBA.pug" lang="pug"></template>
